import { RecordItemI } from '@interfaces/scheduller/record-itemI';
import { ServiceI } from '@interfaces/services/services';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const recordSlice = createSlice({
    name: 'record',
    initialState: {
        record: undefined,
        service: undefined,
    } as {record: RecordItemI | undefined, service: ServiceI | undefined} ,
    reducers: {
        setRecord: (state, action: PayloadAction<{record: RecordItemI | undefined, service: ServiceI | undefined}>) => {
            state.record = action.payload.record;
            state.service = action.payload.service;
        },
        cleanRecords: (state) => {
            state.record = undefined
            state.service = undefined
        },
    },
});

export const { setRecord,cleanRecords } = recordSlice.actions;
export default recordSlice.reducer;
